import React from 'react';
import logo from './pinata.svg';
import elmLogo from './elm-logo.png';
import typescriptLogo from './typescript-logo.png';
import javascriptLogo from './javascript-logo.png';
import nodeLogo from './node-logo.png';
import jestLogo from './jest-logo.png';
import jasmineLogo from './jasmine-logo.png';
import chaiLogo from './chai-logo.png';
import mochaLogo from './mocha-logo.png';
import reactLogo from './react-logo.png';
import reduxLogo from './redux-logo.png';
import ramdaLogo from './ramda-logo.png';
import flowLogo from './flow-logo.png';
import webpackLogo from './webpack-logo.png';
import gruntLogo from './grunt-logo.png';
import gulpLogo from './gulp-logo.svg';
import dockerLogo from './docker-logo.png';
import mysqlLogo from './mysql-logo.png';
import mongoLogo from './mongo-logo.png';
import gitLogo from './git-logo.png';
import circleciLogo from './circleci-logo.png';
import sketchLogo from './sketch-logo.png';
import serverlessLogo from './serverless-logo.png';
import atlassianLogo from './atlassian-logo.ico';
import awsLogo from './aws-logo.ico';

import './App.css';

import { Route, Link } from "react-router-dom";

const Nav = (props) => (
  <React.Fragment>
    <nav>
      <ul>
        <li>
          <Link className="logo" to="/"><img className="nav-logo" src={logo} /></Link>
        </li>
        <li>
          <Link className={window.location.pathname.startsWith("/about") ? "active" : ""} to="/about">About</Link>
        </li>
        <li>
          <Link className={window.location.pathname.startsWith("/services") ? "active" : ""} to="/services">Services</Link>
        </li>
        <li>
          <Link className={window.location.pathname.startsWith("/what-we-use") ? "active" : ""} to="/what-we-use">What we use</Link>
        </li>
      </ul>
    </nav>
    <main style={{ height: `${window.location.pathname.startsWith("/services") ? "80vh" : ""}` }}>
      <Route exact path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/services" component={Services} />
      <Route path="/what-we-use" component={WhatWeUse} />
    </main>
    {
      window.location.pathname.startsWith("/about") &&
      <img className="about-us" src={logo} />
    }
    {
      window.location.pathname.startsWith("/services") &&
      <img className="services-left" src={logo} />
    }
  </React.Fragment>
);

const Home = () => (
  <React.Fragment>
    <h1>Pixel Pinata</h1>
    <h3 className="home-sub-title">Software Consultancy</h3>
    <svg className="pinata" width="35px" height="62px" viewBox="0 0 35 62" version="1.1">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-2">
          <g id="Group" transform="translate(0.000000, 23.000000)">
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="0" y="7" width="13" height="6"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="19" width="30" height="12"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="27" width="3" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="32" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="32" y="27" width="3" height="9"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="11" width="8" height="12"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="7" y="0" width="6" height="8"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="2" y="5" width="8" height="6"></rect>
          </g>
          <rect id="Rectangle" fill="#FFFFFF" x="20" y="0" width="1" height="45"></rect>
        </g>
      </g>
    </svg>
  </React.Fragment>
);

const About = () => (
  <section>
    <h2>About...</h2>
    <p>
      We're Pixel Pinata, a no nonsense software consultancy established in 2018 and based in Manchester, England. Our agile team
      of passionate and experienced software engineers have worked with well known small to large businesses to help
      build and excel their software offering.
    </p>
    <svg className="about-pinata" width="35px" height="39px" viewBox="0 0 35 39" version="1.1">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-2">
          <g id="Group">
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="0" y="7" width="13" height="6"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="19" width="30" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="27" width="3" height="12"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="32" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="32" y="27" width="3" height="9"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="11" width="8" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="7" y="0" width="6" height="8"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="2" y="5" width="8" height="6"></rect>
          </g>
        </g>
      </g>
    </svg>
  </section>
);

const Services = () => (
  <section>
    <h2>Services...</h2>
    <h3>What we do...</h3>
    <p>
      We specialise in custom front-end, backend and mobile application development following designs right down to the pixel. We work with clients
      that share our passion for crafting great user experiences and software applications to help their businesses grow on and offline.
    </p>
    <h3>What we don't...</h3>
    <p>
      We don't specialise in WordPress, quick rough and ready web applications and builds. If you want a Magento eCommerce
      website there are plenty of digital agencies out there that will be able to help you. Unfortunately, it's not us.
    </p>
    <h3>Still interested...?</h3>
    <p>
      Email hey[at]pixelpinata.io with your ideas!
    </p>
    <svg className="services-pinata" width="35px" height="39px" viewBox="0 0 35 39" version="1.1">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-2">
          <g id="Group">
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="0" y="7" width="13" height="6"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="19" width="30" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="27" width="3" height="12"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="32" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="32" y="27" width="3" height="9"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="11" width="8" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="7" y="0" width="6" height="8"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="2" y="5" width="8" height="6"></rect>
          </g>
        </g>
      </g>
    </svg>
  </section>
);

const WhatWeUse = () => (
  <section>
    <h2>What we use...</h2>
    <p>
      We've been heavily involved in the <span style={{ color: "yellow" }}>JavaScript</span> eco-system for years at Pixel Pinata, so we play to our strengths.
      Here are some of the technologies and practices we use on a daily basis.
    </p>
    <div className="row">
      <div className="column">
        <h6>Languages & Frameworks</h6>
        <ul>
          <li><img className="techstack-image" src={elmLogo} /><span>Elm</span></li>
          <li><img className="techstack-image" src={typescriptLogo} /><span>TypeScript</span></li>
          <li><img className="techstack-image" src={javascriptLogo} /><span>JavaScript</span></li>
          <li><img className="techstack-image" src={nodeLogo} /><span>Node</span>/Express</li>
        </ul>
      </div>
      <div className="column">
        <h6>Testing Frameworks & Runners</h6>
        <ul>
          <li><img className="techstack-image" src={jestLogo} /><span>Jest</span></li>
          <li><img className="techstack-image" src={jasmineLogo} /><span>Jasmine</span></li>
          <li><img className="techstack-image" src={chaiLogo} /><span>Chai</span></li>
          <li><img className="techstack-image" src={mochaLogo} /><span>Mocha</span></li>
        </ul>
      </div>
    </div>
    <div className="row">
      <div className="column">
        <h6>Front-end Libraries & Frameworks</h6>
        <ul>
          <li><img className="techstack-image" src={reactLogo} /><span>React</span></li>
          <li><img className="techstack-image" src={reduxLogo} /><span>Redux</span></li>
          <li><img className="techstack-image" src={ramdaLogo} /><span>Ramda</span></li>
          <li><img className="techstack-image" src={flowLogo} /><span>Flow</span></li>
        </ul>
      </div>
      <div className="column">
        <h6>Front-end Automation & Bundlers</h6>
        <ul>
          <li><img className="techstack-image" src={webpackLogo} /><span>Webpack</span></li>
          <li><img className="techstack-image" src={gruntLogo} /><span>Grunt</span></li>
          <li><img className="techstack-image" src={gulpLogo} /><span>Gulp</span></li>
        </ul>
      </div>
    </div>
    <div className="row">
      <div className="column">
        <h6>DevOps/Database Systems</h6>
        <ul>
          <li><img className="techstack-image" src={dockerLogo} /><span>Docker</span></li>
          <li><img className="techstack-image" src={awsLogo} /><span>AWS</span></li>
          <li><img className="techstack-image" src={mysqlLogo} /><span>MySql</span></li>
          <li><img className="techstack-image background-white" src={mongoLogo} /><span>Mongo</span></li>
        </ul>
      </div>
      <div className="column">
        <h6>Everything else...</h6>
        <ul>
          <li><img className="techstack-image" src={circleciLogo} /><span>Circle CI</span></li>
          <li><img className="techstack-image" src={gitLogo} /><span>Git</span></li>
          <li><img className="techstack-image" src={atlassianLogo} /><span>Atlassian Suite</span></li>
          <li><img className="techstack-image" src={sketchLogo} /><span>Sketch</span></li>
          <li><img className="techstack-image" src={serverlessLogo} /><span>Serverless</span></li>
          <li><img className="techstack-image" src={reactLogo} /><span>React Native</span></li>
        </ul>
      </div>
    </div>
    <svg className="what-we-use-pinata" width="35px" height="39px" viewBox="0 0 35 39" version="1.1">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-2">
          <g id="Group">
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="0" y="7" width="13" height="6"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="19" width="30" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="27" width="3" height="12"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="5" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="32" y="36" width="3" height="3"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="32" y="27" width="3" height="9"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="5" y="11" width="8" height="12"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="7" y="0" width="6" height="8"></rect>
            <rect id="Rectangle" fill="#9B9B9B" x="2" y="5" width="8" height="6"></rect>
          </g>
        </g>
      </g>
    </svg>
  </section>
)

export default Nav;



// WEBPACK FOOTER //
// ./src/App.js